import React, { useState } from "react";
import { bool, number, string } from "prop-types";

import { calculateAspectRatio } from "../../utilities/calculateAspectRatio";
import { sendExperimentId } from "../../utilities/sendExperimentId";
import * as S from "./styled";

const CMSBanner = ({
  altText,
  creativeId,
  imageUrl,
  isHiddenSeparator,
  segmentTargetExperimentId,
  segmentTargetId,
  url,
  ...passThroughProps
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const handleBannerClick = () => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "content_banners",
      event_action: "click",
      event_label: `creative_id:${creativeId}|segment_target_id:${segmentTargetId}${sendExperimentId(
        segmentTargetExperimentId
      )}`
    });
  };
  const {
    creativeMaxHeight,
    creativeMinHeight,
    creativeWidth
  } = passThroughProps;
  const aspectRatio = imgLoaded
    ? "auto"
    : calculateAspectRatio({
        creativeMaxHeight,
        creativeMinHeight,
        creativeWidth
      });

  return (
    <S.CMSBannerWrapper {...passThroughProps}>
      {url ? (
        <S.Link
          href={`${url}?creative_id=${creativeId}&segment_targets_id=${segmentTargetId}`}
          onClick={handleBannerClick}
          rel="noopener noreferrer"
          target="_blank"
        >
          <S.ImageWrapper aspectRatio={aspectRatio}>
            <S.Image
              alt={altText}
              onLoad={() => {
                setImgLoaded(true);
              }}
              src={imageUrl}
            />
          </S.ImageWrapper>
        </S.Link>
      ) : (
        <S.ImageWrapper aspectRatio={aspectRatio}>
          <S.Image
            alt={altText}
            onLoad={() => {
              setImgLoaded(true);
            }}
            src={imageUrl}
          />
        </S.ImageWrapper>
      )}
      {!isHiddenSeparator && <S.Separator />}
    </S.CMSBannerWrapper>
  );
};

CMSBanner.defaultProps = {
  creativeMaxHeight: null,
  creativeMinHeight: null,
  creativeWidth: null,
  isHiddenSeparator: false,
  segmentTargetExperimentId: null,
  url: ""
};

CMSBanner.propTypes = {
  altText: string.isRequired,
  creativeId: number.isRequired,
  creativeMaxHeight: number,
  creativeMinHeight: number,
  creativeWidth: number,
  isHiddenSeparator: bool,
  imageUrl: string.isRequired,
  segmentTargetExperimentId: number,
  segmentTargetId: number.isRequired,
  url: string
};

export default CMSBanner;
